import Vue from 'vue'
import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {far} from '@fortawesome/free-regular-svg-icons'
import {faInfoCircle, faTrash, fas} from '@fortawesome/free-solid-svg-icons'

library.add(fas, far)
library.add(faInfoCircle)
library.add(faTrash)

Vue.component('font-awesome-icon', FontAwesomeIcon)
